import { createAction } from 'typesafe-actions';
import { ProductInSetClickType } from './types';
import { PRODUCT_IN_SET_CLICK } from 'features/related-products';
import {
  getPrimaryPriceCb,
  getProductBelongFromSource,
  getProductPriceCategoryUtil,
} from 'features/product-info';
import { put, select, call, takeEvery } from 'redux-saga/effects';
import { getStocksInStores, StoreStockData } from 'features/goods-supply';
import { selectProductId } from '../selectors';

/**
 * Событие должно срабатывать при клике по товару.
 * @see {@link http://10.203.56.19:8000/assignment/group/cd1bece5e52a4ebf86dd77b514e8ac6f/view Клик по товарам в составе комплекта (комплекты)}
 */

export const gaProductInSetClick = createAction('GA:clickProduct')<ProductInSetClickType>();

export function* putGaProductInSetClick(action: ReturnType<typeof PRODUCT_IN_SET_CLICK>) {
  const { productInfo, elementName, index } = action.payload;

  const { productId, source, price, displayedName } = productInfo;

  const stocks: StoreStockData[] = yield select(getStocksInStores);

  const primaryPrice = getPrimaryPriceCb(price);

  const productBelong = getProductBelongFromSource(source);

  const komplektyId: string = yield call(selectProductId);

  const productTag = getProductPriceCategoryUtil(productInfo, primaryPrice, stocks);

  yield put(
    gaProductInSetClick({
      elementType: 'product',
      elementBlock: 'komplektyDetail / products',
      elementName,
      productName: displayedName ?? '',
      productId,
      productPrice: price?.main_price.toString() ?? '',
      productBelong,
      productTag,
      productDiscount: primaryPrice.discountPercent?.toString() ?? null,
      productPrevPrice: primaryPrice.prevPrice?.toString() ?? null,
      productPosition: index.toString(),
      komplektyId,
    }),
  );
}

export function* runProductInSetClickDetector() {
  yield takeEvery(PRODUCT_IN_SET_CLICK, putGaProductInSetClick);
}
